<template>
     <div class="container header-margin">

        <div class="text-center p-2 text-color text-area">
            <h2 class="main_title">{{ $t('aube_quest.registration.title') }}</h2>
        </div>

        <div class="tab-content p-2 text-center" v-if="(! isLoaded)">
            {{ $t('loading') }}
        </div>

        <div class="tab-content p-2 text-center" v-if="(isLoaded) && (! isValidQuestId.required)">
            {{ $t('aube_quest.verify_error.required_qId') }}
        </div>
         <div class="tab-content p-2 text-center" v-if="isLoaded && isValidQuestId.connected && !isValidQuestId.temp">
             <div class="outer style-pc">
                 <div class="inners">
                     <div style="text-align: left;">{{ $t('aube_quest.registration.main1') }}</div>
                     <div style="text-align: left; margin-top:20px">{{ $t('createUserMessage.closeWindow') }}</div>
                 </div>
             </div>
         </div>
         <div class="tab-content p-2 text-center" v-if="(isLoaded) && (isValidQuestId.temp)">
             <div class="outer style-pc">
                 <div class="inners">
                     <div style="text-align: left;">{{ $t('aube_quest.registration.temp1') }}</div>
                     <div style="text-align: left;">{{ $t('aube_quest.registration.temp2') }}</div>
                     <div style="text-align: left; margin-top:20px">{{ $t('createUserMessage.closeWindow') }}</div>
                 </div>
             </div>
         </div>

        <div class="tab-content p-2" v-if="isLoaded && isValidQuestId.required && !isValidQuestId.connected && !isValidQuestId.temp">
            <div class="info-box">
                <small class="text-muted">{{ $t('aube_quest.registration.title_quest_info') }}</small>
                <div>Quest ID: {{ formData.quest_id }}</div>
                <div>Connector ID: {{ formData.connectorMemberId }}</div>
                <div>{{ $t('aube_quest.connector_start_date') }}: {{ formData.joinedDate }}</div>
                <div v-if="errors.quest_id" class="error-message w-100 pre">{{ $t('aube_quest.verify_error.' + errors.quest_id) }}</div>
                <div v-if="errors.quest_id" class="error-message w-100 pre">{{ $t('aube_quest.verify_error.' + errors.quest_id) }}</div>
            </div>

            <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-create-tab">
                <div class="row no-gutters text-center navigation">
                <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-center">{{ $t('auth.navigationForceclub.title1') }}</p></div>
                <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationForceclub.title2') }}</p></div>
                <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationForceclub.title3') }}</p></div>
                <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationForceclub.title4') }}</p></div>
            </div>

                <div class="text-center p-2 text text-color text-area">
                    <h3 class="sub_title">{{ $t('aube_quest.registration.signup') }}</h3>
                </div>

                <form @submit.prevent="handleOnSubmit">
                    <div class="wrap-padding">
                        <div class="text-area">
                            <p class="pre">{{ $t('aube_quest.registration.send_mail_notice') }}</p>
                        </div>
                        <div class="form-group row">
                            <label style="width:180px; margin-left:17px;" for="account" class="pre">{{ $t('aube_quest.registration.email_qId') }}</label>
                            <div class="col-sm-8">
                                <input v-model="formData.account" type="text" id="account" name="account"
                                class="form-control"
                                v-bind:class="{ 'is-invalid': errors.account}"/>
                                <div v-if="errors.account" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.account) }}</div>
                            </div>
                            <div v-if="(!errors.account)" class="invalid-errors-hiddens"></div>
                        </div>

                        <div class="form-group row">
                            <label style="width:180px; margin-left:17px;" class="form-check-label tosAgreeForm pre" v-html="$t('aube_quest.registration.email_confirmation_qId')" for="tosAgree">
                            </label>
                            <div class="col-sm-8">
                                <input v-model="formData.account_confirmation" type="text" id="account_confirmation" name="account_confirmation"
                                class="form-control"
                                v-bind:class="{ 'is-invalid': errors.account_confirmation}"/>
                                <div v-if="errors.account_confirmation" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.account_confirmation) }}</div>
                            </div>
                            <div v-if="(!errors.account_confirmation)" class="invalid-errors-hiddens"></div>
                        </div>

                        <div class="text-center mt-4">
                            <div class="form-check">
                                <input v-model="formData.tosAgree" name="tosAgree" type="checkbox"
                                    class="form-check-input tosAgreeForm" id="tosAgree"
                                    v-bind:class="{ 'is-invalid': errors.tosAgree}">
                                <label class="form-check-label tosAgreeForm" v-html="$t('aube_quest.registration.agree_label_qId')" for="tosAgree">
                                </label>
                                <div v-if="errors.tosAgree" class="invalid-feedback invalid-tosAgree" style="margin-left:11px">{{ $t('errors.' + errors.tosAgree) }}</div>
                            </div>
                            <div v-if="(!errors.tosAgree)" class="invalid-tosAgree-hiddens"></div>
                        </div>

                        <div class="text-center">
                            <button type="submit" style="width: 115px;" class="btn btn-primary active-color-box" :class="submitBtnDisabled() ? 'btn-disable' : ''" :disabled="submitBtnDisabled()">{{ $t('auth.confirmBtn') }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import QuestService from '../../../../services/QuestService';
    import languageService from "../../../../services/LanguageService";
    import questService from "../../../../services/QuestService";

    export default {
        name: 'login-module',

        created() {
            this.formData.quest_id = localStorage.getItem('questId');
            if (!localStorage.getItem('questId')) {
                this.errors.quest_id = 'quest_id_not_found';
            }
            this.checkQuestID();
            this.maxHeight();
        },
        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                mailData: this.getDefaultFields(),
                submitted: false,
                isLoaded: false,
                isValidQuestId: {
                    required: true,
                    connected: false,
                    temp: false,
                },
                getMemberType: true
            }
        },

        methods: {
            maxHeight(){
                setTimeout(()=>{
                    if(document.getElementById("box1") != null){
                        let box1 = document.getElementById('box1').clientHeight
                        let box2 = document.getElementById('box2').clientHeight
                        let box3 = document.getElementById('box3').clientHeight
                        let box4 = document.getElementById('box4').clientHeight
                        let maxHeight = Math.max(box1,box2,box3,box4);
                        document.getElementById('box1').style.height = maxHeight+'px'
                        document.getElementById('box2').style.height = maxHeight+'px'
                        document.getElementById('box3').style.height = maxHeight+'px'
                        document.getElementById('box4').style.height = maxHeight+'px'
                    }
                },3000)
            },
            getDefaultFields() {
                return {
                    account: '',
                    account_confirmation: '',
                    tosAgree: false,
                    quest_id: '',
                    connectorMemberId: '',
                    joinedDate: '',
                };
            },

            submitBtnDisabled() {
                return this.submitted;
            },

            openTermsWindow() {
                let r = this.$router.resolve({ name: 'terms' });
                if (r && r.href) {
                    window.open(r.href, '_blank');
                }
            },
            async checkQuestID() {
                if (this.formData.quest_id === '') {
                    this.isValidQuestId.required = false;
                    this.isLoaded = true;

                    return;
                }
                await this.getConnector(this.formData.quest_id);
                await this.getQuestConnectedStatus(this.formData.quest_id);
                this.isLoaded = true;
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    this.submitted = true;
                    const languageCode = await languageService.getCurrentLanguageCode();
                    await QuestService.createBaseUser({
                        ...this.formData,
                        tosAgree: this.formData.tosAgree === true ? true : null,
                        languageCode: languageCode,
                    });
                    sessionStorage.mailData = JSON.stringify(this.formData)
                    this.$router.push('/registration-quest/check-email');
                } catch (err) {
                    if (err && err.response && err.response.data && err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                if (errItem.field === 'API_Error') {
                                    location.href='https://www.aube-quest.com/login';
                                }
                                if (typeof(errItem.field) === 'string') {
                                    this.errors[errItem.field] = errItem.message[0];
                                } else {
                                    for(let field in errItem.field) {
                                        if (errItem.field.hasOwnProperty(field)) {
                                            this.errors[errItem.field[field]] = errItem.message[0];
                                            this.$router.push('/registration-quest/error?message=' + errItem.field);
                                        }
                                    }
                                }
                            } else {
                                this.errors.quest_id = errItem.message[0];
                            }
                        })
                    } else {
                        console.error('Network error or unexpected error:', err);
                    }
                } finally {
                    this.submitted = false;
                }
            },
            async getConnector (questId) {
                try {
                    const result = await questService.getConnectorByQuestId(questId);
                    this.formData.connectorMemberId = result.data.connector_id;
                    this.formData.joinedDate = result.data.joined_date;
                } catch (error) {
                }
            },
            async getQuestConnectedStatus (questId) {
                try {
                    const result = await QuestService.getQuestConnectStatus(questId);
                    this.isValidQuestId.connected = result.data;
                    if (!result.data) {
                        await this.getTemporaryRegistrationCheck(questId);
                    }
                } catch (e) {
                    this.submitted = false;
                } finally {
                    this.isLoaded = true;
                }
            },
            async getTemporaryRegistrationCheck (questId) {
                try {
                    const result = await QuestService.getTemporaryRegistrationCheck(questId);
                    this.isValidQuestId.temp = result.data;
                } catch (e) {
                    this.submitted = false;
                } finally {
                    this.isLoaded = true;
                }
            }
        }
    }
</script>

<style scoped>
    .main_title{
        margin-bottom: 30px;
    }
    .sub_title{
        margin-bottom: 15px;
    }
    .outer{
        text-align: center;
    }
    .inners{
        display: inline-block;
    }
    .tos.form-control:disabled {
        background-color: white;
    }
    .tosAgreeForm {
        cursor: pointer;
    }
    .pre {
        white-space: pre-wrap;
    }
    .text-color {
        color: #451493;
    }
    .active-color-box {
        background: #451493;
        border-color:#451493;
    }
    .non-active-color-box {
        background: #bdbebd;
    }
    .text {
        font-size: 25px;
    }
    .navigation {
        padding-bottom:40px;
    }
    .text-area {
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4 {
        outline: 1px solid #FFF;
    }
    .text-box {
        display: block;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }
    /*ボタンのスタイル*/
    .btn-primary{
        margin-top: 10px;
    }

    .form-control.is-invalid {
       border-color: #e3342f;
    }

    .form-control.is-invalid:focus {
        box-shadow: 0 0 0 0.2rem rgb(227 52 47 / 25%);
    }
    .info-box {
        background-color: #f7f7f7;
        border-radius: 6px;
        padding: 12px 16px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #ebeaea;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
    .info-box small {
        display: block;
        color: #6c757d;
        margin-bottom: 4px;
        font-size: 0.85rem;
    }
    .info-box div {
        font-weight: 500;
        font-size: 0.95rem;
    }

    .error-message {
        display: block;
        margin-top: 0.25rem;
        font-size: 0.875rem;
        color: #e3342f;
        line-height: 1.4;
        word-wrap: break-word;
    }

    .btn-disable {
        color: #fff !important;
        background-color: #c6c6c6 !important;
        border-color: #c6c6c6 !important;
        cursor: not-allowed;
    }

    .btn-disable:hover,
    .btn-disable:focus {
        color: #fff !important;
        background-color: #c6c6c6 !important;
        border-color: #c6c6c6 !important;
        box-shadow: none !important;
    }

    /*PC用css*/
    @media screen and (min-width: 991px) {
        .style-pc{
            margin-top: 50px;
        }
    }
    @media screen and (max-width: 991px) {
        .style-pc{
            margin-top: 0px;
        }
    }


    /*PC PAD用css*/
    @media screen and (min-width: 479px) {
        .invalid-errors-hiddens{
            visibility: hidden;
            height: 77px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height: 40px;
            height: auto !important;
            height: 40px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-tosAgree-hiddens{
            visibility: hidden;
            height: 11px;
            margin-top: 5px;
            margin-bottom: 4px;
        }
        .invalid-tosAgree{
            min-height: 10px;
            height: auto !important;
            height: 10px;
            margin-top: 3px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) {
        .invalid-errors-hiddens{
            visibility: hidden;
            height: 51px;
            margin-top: 4px;
            margin-bottom: 9px;
        }
        .invalid-errors{
            min-height: 18px;
            height: auto !important;
            height: 18px;
            margin-top: 4px;
            margin-bottom: 5px;
        }
        .invalid-tosAgree-hiddens{
            visibility: hidden;
            height: 13px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-tosAgree{
            min-height:10px;
            height: auto !important;
            height: 10px;
            margin-top: 4px;

        }
        .form-group {
            margin-bottom: 0px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .main_title{
            margin-bottom: 0px;
            font-size: 1.575rem;
        }
        .sub_title{
            margin-bottom: 0px;
            font-size: 1.3rem;
        }
        .navigation{
            padding-bottom:15px;
        }
    }
    @media screen and (min-width: 991px) {
        .wrap-padding{
            padding-left:29px;
        }
    }
    @media screen and (max-width: 991px) {
        .wrap-padding{
            padding-left:12px;
        }
    }

</style>
